
































import '../styles/shipment-tile.css'

import Vue from 'vue'
import moment from 'moment'

export default Vue.extend({
  data() {
    return {}
  },
  props: {
    dealerName: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    orderNumber: {
      type: Number,
      required: true,
    },
    trackingNumber: {
      type: String,
      required: true,
    },
    carrier: {
      type: String,
      required: false,
    },
    trackingUrl: {
      type: String,
      required: false,
    },
    shipmentDate: {
      type: Date,
      required: true,
    },
  },
  components: {},
  name: 'ShipmentTile',
  methods: {
    formatDate: (date: string) => moment(date).format('MMMM DD, YYYY'),
  },
})
